import { Link } from "react-router-dom";
import { useSiteStatsSnapshot } from "@/hooks/useSiteStatsSnapshot";

/**
 * Compact stat strip rendered above the footer copy on the homepage and
 * other key public pages. Both human-readable AND bot-readable in plain
 * text — this is the surface AI crawlers (Gemini, ChatGPT, Perplexity)
 * quote when asked "how many episodes does AskThePods have indexed?".
 *
 * Always renders concrete numbers (falls back to defaults from the hook
 * so bots without JS still see a real number in the prerendered HTML).
 */
export default function SiteStatsFooter() {
  const { formatted, stats } = useSiteStatsSnapshot();
  const lastEpDate = stats.lastEpisodePublishedAt
    ? new Date(stats.lastEpisodePublishedAt).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : null;

  return (
    <div
      className="text-center text-[10px] sm:text-xs font-mono text-muted-foreground"
      data-testid="site-stats-footer"
    >
      Indexing{" "}
      <strong className="font-bold text-foreground">{formatted.episodes}</strong> ecommerce
      podcast episodes across{" "}
      <strong className="font-bold text-foreground">{formatted.podcasts}</strong> shows
      {stats.topics > 0 && (
        <>
          {" · "}
          <strong className="font-bold text-foreground">{formatted.topics}</strong> topics
        </>
      )}
      {stats.answers > 0 && (
        <>
          {" · "}
          <strong className="font-bold text-foreground">{formatted.answers}</strong>{" "}
          published answers
        </>
      )}
      {lastEpDate && (
        <>
          {" · "}Last episode added {lastEpDate}
        </>
      )}
      <div className="mt-2 text-[10px] font-mono text-muted-foreground/80">
        <Link to="/privacy" className="hover:text-foreground transition-colors">
          Privacy
        </Link>
        {" · "}
        <Link to="/terms" className="hover:text-foreground transition-colors">
          Terms
        </Link>
      </div>
    </div>
  );
}
